import { render } from "./badgeSuccess.vue?vue&type=template&id=eedd2ce8"
import script from "./badgeSuccess.vue?vue&type=script&lang=js"
export * from "./badgeSuccess.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/new_dev_tis/frontend/admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__